import React from 'react'
import { Container } from 'react-bootstrap'
import { GiTruck, GiHealing } from 'react-icons/gi';
import { SiOxygen } from 'react-icons/si';

export default function FactsMaca() {
    return (
        <section className="py-4">
            <Container>
                <div className="facts-cont">
                    <h2 className="fs-3 mb-4 fw-bold make-serif text-center secondary-text"><span className="fw-light make-serif">Facts about </span>Macademia Nuts</h2>
                    <div className="facts-cards mt-3 shadow text-center">
                        <div className="light-gradient">
                            <GiHealing size="3.5rem" className="center-item main-lime-text"  />
                            <h5 className="fw-medium d-inline-block secondary-text my-3">Rich in Nutrients</h5>
                            <p className="secondary-text small-text-02">They are rich in Vitamin minerals and fiber, yet low in carbs and sugar, and boasts of healthy monoursalturated fats.</p>
                        </div>
                        <div className="main-background">
                            <SiOxygen size="3.5rem" className="center-item main-lime-text"  />
                            <h5 className="fw-medium d-inline-block white-text my-3">Antioxidants</h5>
                            <p className="white-text small-text-02">They are loaded with flavonoids and tocotrienols, antioxidants that safeguard your body against cellular damage and diseases.</p>
                        </div>
                        <div className="light-gradient">
                            <GiTruck size="3.5rem" className="center-item main-lime-text"  />
                            <h5 className="fw-medium d-inline-block secondary-text my-3">Harvesting</h5>
                            <p className="secondary-text small-text-02">Macademia Nuts are not picked from trees, but are fully ripped whn they fall and are then harvested.</p>
                        </div>
                    </div>
                </div>
            </Container>
  
        </section>
    )
}
